import React from 'react';
import PropTypes from 'prop-types';
import messages from '../messages';

import MenuInputWithTitle from '../../components/MenuInputWithTitle';

const labels = {
  'Undergraduate Applications Accepted': messages.applicationsAccepted,
  'Undergraduate Applications Received': messages.applicationsReceived,
};

const AcceptanceRate = ({ onChange, initialValue }) => (
  <React.Fragment>
    {Object.keys(initialValue).map((key) => initialValue[key] && (
      <MenuInputWithTitle
        type="number"
        min="0"
        max="999999"
        maxLength="6"
        title={labels[initialValue[key].label]}
        data-cy={`Premium-Hem-Admissions-${initialValue[key].label}-InputField`}
        value={initialValue[key].value}
        key={key}
        onChange={(e) => {
          onChange(e, {
            [key]: { ...initialValue[key], value: e.target.value },
          });
        }}
        isErrorVisible={initialValue[key].showError}
      />
    ))}
  </React.Fragment>
);

AcceptanceRate.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
};

export default AcceptanceRate;
